import { Grid, Bones } from '@simplywallst/ui-core';

import { Item } from './styled';

export const FeedCardItemSkeleton = () => (
  <Item>
    <Grid gap="12px" templateColumns="min-content auto" alignItems="start">
      <div>
        <Bones borderRadius="x5" minHeight="40px" minWidth="40px" />
      </div>
      <Grid rowGap="8px">
        <Bones maxWidth="250px" />
        <Bones maxWidth="250px" />
        <Bones maxWidth="40px" />
      </Grid>
    </Grid>
  </Item>
);
